export default __webpack_public_path__ + "static/media/no_channels_available.77beb95c.svg";